import React from 'react'
import { Box, Button, FormControlLabel, Grid, Typography, IconButton, Checkbox, Switch } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';
import {ReactComponent as PdfDefault} from "../../../../Assets/img/icons/PDF default.svg";
import { useCreateCardDetailContext } from '../../../CreatecardDetailContext';
import QRCode from 'qrcode.react';

const RootBox = styled(Box)({
    padding: 12,
    borderRadius: 4,
    border: '1px solid #D9D9D9'
  });
  
  const BorderedImageBox = styled(Box)({
    border: '1px dashed #0000001F',
    padding: 6,
    textAlign: 'center',
  });
  
  const FileInfoBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontFamily: 'Lato'
  });
  
  const ActionsBox = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    width: '100%'
  });
  
  const GridItemBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
  });

function UploadedFile({ file, onDelete }) {

  const { name, size, type, date, fileCat, data, showQR, visible, fileId } = file;

  const { toggleQR, toggleVisibility } = useCreateCardDetailContext();

  const handleDelete = () => {
    onDelete(fileCat, fileId);
  };

  return (
    <RootBox>
    <Grid container spacing={2}>
      <Grid item xs={2}>
        <GridItemBox>
          <BorderedImageBox>
          {showQR ? (
                <QRCode value={data} size={62} />
              ) : (
                <PdfDefault /> // Placeholder for specifc file-type icon
              )}
          </BorderedImageBox>
        </GridItemBox>
      </Grid>
      <Grid item xs={6}>
        <FileInfoBox>
          <Typography variant="body1">{name}</Typography>
          <Typography variant="body2" sx={{fontSize: "12px"}}>Size: {size} | Added: {date}</Typography>
        </FileInfoBox>
      </Grid>
      <Grid item xs={4} className='pt-1'>
        <ActionsBox>
        <FormControlLabel className='upload-file-checkbox' control={<Checkbox
            color="primary"
            inputProps={{ 'aria-label': 'show QR code' }}
            checked={showQR}
            onChange={() => toggleQR(fileCat, fileId)}
          />} label="Show QR" />
          <IconButton onClick={handleDelete}>
            <DeleteIcon />
          </IconButton>
          <Switch
            color="primary"
            inputProps={{ 'aria-label': 'toggle visibility' }}
            defaultChecked
            size='small'
            className='mt-2'
            onChange={() => toggleVisibility(fileCat, fileId)}
          />
        </ActionsBox>
      </Grid>
    </Grid>
  </RootBox>
  )
}

export default UploadedFile